import React from "react";

const QualityControl = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Quality Control</h5>
      </div>

      <div className="about-box p-4 rounded shadow-lg ">
        <p>
          Taking into consideration the vital importance of Seed Quality, HSDC
          established a separate Quality Control Department in 1982 so as to
          undertake quality checks at various stages of seed production,
          processing, storage &amp; marketing of seeds. HSDC gives top priority
          to all quality aspects i.e. varietal purity, hybrid characteristics,
          vigour, physical purity, genetic purity &amp; seed health.
        </p>

        <p>
          Although, all the quality components are important but the most
          pertinent index is the seed germination &amp; purity for which the
          test procedures and standard have been prescribed by Govt. of India
          and the same are adhered to by the HSDC. In case of Breeder,
          Foundation &amp; Hybrid Seeds, the Grow-Out Test (GOT) are got
          conducted through HSSCA before marketing / allotment of seed
          production program. In case of all Truthful Labelled (T.L.) seeds,
          special field inspections are carried out by the Senior Technical
          Officers of the Corporation so as to assure the quality of seeds.
        </p>

        <h6>Quality Control Seed Testing Lab</h6>

        <p>
          HSDC has established a well equipped Quality Control Seed Testing Lab
          at its Regional office Complex, Umri. 100% carry-over seed lots and
          10% fresh seed lots are got tested in this Lab in addition to that of
          HSSCA tests, so as to conform to quality parameters before it is sold
          to the farmers.
        </p>

        <p>
          To ensure an adequate &amp; uniform seed quality, the guidelines and
          instructions are issued from time to time by Quality Control Section
          &amp; all these important guidelines have been compiled &amp; printed
          in the form of Quality Control Circulars in a Book called "HSDC Manual
          of Instructions Part-I &amp; Part-II". The field staff working in
          Quality Control Section to visit all six Processing Plants, Seed
          Storage Godowns and also undertake field inspections at critical
          stages so as to ensure the quality of seed. The objective is clear -
          Quality Seed.
        </p>
      </div>
    </div>
  );
};

export default QualityControl;
